module.exports = __webpack_public_path__ + "img/Off Center Stone.836e6903.png";